<template>
  <div>
    <div>
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 14 }">
        <a-form-model-item prop="username" label="用户名">
          <a-input size="large" v-model="form.username" autocomplete="username" @change="onInputChange"/>
        </a-form-model-item>
        <a-form-model-item prop="password" label="密码">
          <a-input-password size="large" v-model="form.password" autocomplete="current-password" @change="onInputChange"/>
        </a-form-model-item>
      </a-form-model>
    </div>
    <a-row>
      <a-col :span="14" offset="5">
        <a-button type="primary" size="large" :loading="isLoading" style="width: 100%;" @click="login">登录</a-button>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import {getToken} from '@/api/user';
import Cookies from 'js-cookie';

export default {
  name: 'Login',
  data() {
    return {
      selectedKeys: ['login'],
      isLoading: false,
      form: {
        number: '2',
        username: '',
        password: '',
      },
      reg: {
        email: '',
        password: '',
        code: '',
        username: ''
      },
      rules: {
        number: [
          {required: true, message: '请输入公司编号', trigger: 'change'},
        ],
        username: [
          {required: true, message: '请输入用户名', trigger: 'change'},
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'change'},
        ],
      },
      second: 60,
      is_send: false,
      warn: '',
      code_interval: null
    };
  },
  methods: {
    onInputChange(e) {
      const el = e.target || e;
      if (el && el.tagName === 'INPUT') {
        const value = el.value;
        const prop = el.type === 'password' ? 'password' : 'username';
        if (value && !this.form[prop]) {
          this.form[prop] = value;
        }
      }
    },
    syncAutofillValues() {
      const inputs = this.$el.querySelectorAll('input');
      inputs.forEach(input => {
        if (!input.value) return;
        if (input.type === 'password' && !this.form.password) {
          this.form.password = input.value;
        } else if (!this.form.username) {
          this.form.username = input.value;
        }
      });
    },
    login() {
      this.syncAutofillValues();
      this.$refs.form.validate(valid => {
        if (valid) {
          this.isLoading = true;
          getToken(this.form).then(data => {
            this.$message.success('登录成功');
            Cookies.set('access', data.access);
            Cookies.set('refresh', data.refresh);
            window.location.reload();
            this.$router.push('/basicData/client');
          }).catch(err => {
            this.$message.error(err.message);
          })
            .finally(() => {
            this.isLoading = false;
          });
        }
      });
    },
  },
  created() {
    if (Cookies.get('access') && Cookies.get('refresh')) {
      this.$router.replace('/basicData/client');
    }
  },
}
</script>